import React, { useState, useEffect } from "react";
import * as S from "./ArticleTitle.sc";
import { useRouter } from "next/router";
import ShareButton from "../../components/ShareButton/ShareButton";
import IcomoonReact from "icomoon-react";
import iconSet from "../../fonts/selection.json";
import { convertDate } from "../../services/date";

const ArticleTitle = ({ article, showShareButtons, authors }) => {
  const [origin, setOrigin] = useState("");
  const { asPath, pathname } = useRouter();
  useEffect(() => {
    const location = window.location.href;
    const url = new URL(location);
    setOrigin(url.origin);
  }, []);
  return (
    <div>
      <S.Title>{article.title}</S.Title>
      <S.Row>
        {(article.published_at || authors) && (
          <div>
            {article.published_at && (
              <S.Date>{convertDate(article.published_at)}</S.Date>
            )}
            {authors && authors.length > 0 && (
              <S.Author>
                autor: {authors.map((author) => `${author.name} `)}
              </S.Author>
            )}
          </div>
        )}
        {showShareButtons && (
          <S.Flex key={article.title.replace(/\s+/, "")}>
            <ShareButton
              url={`${origin}${asPath}`}
              allowCode={pathname === "/kancelarie/[lawfirm]"}
            />
            <S.PrintButton onClick={() => window.print()}>
              <IcomoonReact
                iconSet={iconSet}
                color="#4D75E1"
                size={16}
                icon="print"
                style={{ marginRight: 5 }}
              />
              DRUKUJ
            </S.PrintButton>
          </S.Flex>
        )}
      </S.Row>
    </div>
  );
};

export default ArticleTitle;
